module.exports = __webpack_public_path__ + "static/media/w_w_hw_35.abf1a2d0.png";